(function () {
  'use strict';

  function computeStage(current, milestones) {
    if (!milestones.length) return 0;
    var stage = 0;
    for (var i = 0; i < milestones.length; i++) {
      if (current >= milestones[i]) stage++;
      else break;
    }
    return stage;
  }

  function getNextMilestone(current, milestones) {
    for (var i = 0; i < milestones.length; i++) {
      if (current < milestones[i]) return milestones[i];
    }
    return null;
  }

  function computePercentage(current, milestones) {
    var next = getNextMilestone(current, milestones);
    if (next === null) return milestones.length === 0 ? 0 : 100;
    return Math.min(100, Math.floor((current / next) * 100));
  }

  function parseMilestones(str) {
    if (!str) return [];
    return str
      .split(',')
      .map(function (s) { return parseInt(s.trim(), 10); })
      .filter(function (n) { return isFinite(n) && n > 0; })
      .sort(function (a, b) { return a - b; });
  }

  function renderMilestoneChips(container, milestones, current, markChar) {
    container.textContent = '';
    milestones.forEach(function (m, idx) {
      var span = document.createElement('span');
      span.className = 'ht-w-members__chip';
      var reached = current >= m;
      span.textContent = (reached ? markChar : '') + m;
      if (reached) span.classList.add('ht-w-members__chip--reached');
      container.appendChild(span);
      if (idx < milestones.length - 1) {
        var dot = document.createElement('span');
        dot.className = 'ht-w-members__chip-sep';
        dot.textContent = ' · ';
        container.appendChild(dot);
      }
    });
  }

  function render(root, current) {
    var milestones = parseMilestones(root.dataset.htwMembersMilestones);
    var stage = computeStage(current, milestones);
    var next = getNextMilestone(current, milestones);
    var pct = computePercentage(current, milestones);
    var markChar = root.dataset.htwMembersMark || '✓';

    var currentEl = root.querySelector('[data-htw-members-current]');
    if (currentEl) currentEl.textContent = current.toLocaleString('ja-JP');

    var nextEl = root.querySelector('[data-htw-members-next]');
    if (nextEl) nextEl.textContent = next !== null ? next.toLocaleString('ja-JP') : '達成!';

    var barEl = root.querySelector('[data-htw-members-bar]');
    if (barEl) {
      barEl.style.width = pct + '%';
      barEl.setAttribute('data-stage', String(stage));
    }

    var chipsEl = root.querySelector('[data-htw-members-milestones-chips]');
    if (chipsEl) renderMilestoneChips(chipsEl, milestones, current, markChar);
  }

  function init(root) {
    var url = root.dataset.htwMembersUrl;
    if (!url) return;

    fetch(url, { credentials: 'omit' })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
      .then(function (data) {
        if (typeof data.current === 'number') render(root, data.current);
      })
      .catch(function (err) {
        console.warn('[ht-w-members] failed to fetch stats:', err);
        var fallbackEl = root.querySelector('[data-htw-members-current]');
        var fallback = fallbackEl ? parseInt(fallbackEl.textContent || '0', 10) : 0;
        render(root, isFinite(fallback) ? fallback : 0);
      });
  }

  function boot() {
    document.querySelectorAll('[data-htw-members]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
